/* eslint-disable import/no-unresolved */
import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Link, useParams } from 'react-router-dom';
import { Language, Wifi } from '@mui/icons-material';
import { Column } from 'primereact/column';
import { IConnectivityStatusByLocation } from '../../../types/Device/DeviceInterfaces';
import { WIFI_SIGNAL } from '../../../constants/enums/deviceEnums';

interface IAccessPointTableProps {
  data: IConnectivityStatusByLocation[];
}
const defaultImg = require('../../../assets/images/wifiSignal/default-wifi.png');
const poorImg = require('../../../assets/images/wifiSignal/very-poor.png');
const goodImg = require('../../../assets/images/wifiSignal/Good.png');
const excellentImg = require('../../../assets/images/wifiSignal/Excellent.png');
const connectedImg = require('../../../assets/images/wifiSignal/Online.png');
const disconnectedImg = require('../../../assets/images/wifiSignal/Offline.png');

export const ConnectivityStatus = ({ data }: IAccessPointTableProps) => {
  const params = useParams();
  const { locationId } = params;
  const controllersSignalClass = (signalStrengthDescription: string) => {
    switch (signalStrengthDescription) {
      case WIFI_SIGNAL.POOR:
        return 'text-warning';
      case WIFI_SIGNAL.GOOD:
        return 'text-success';
      case WIFI_SIGNAL.EXCELLENT:
        return 'text-success';
      default:
        return 'text-muted';
    }
  };

  const returnImage = (signal: {
    image: string;
    description: string;
    signalStrength: number;
  }) => {
    return (
      <div>
        <img src={signal.image} alt={signal.description} width={20} />
        <span className={controllersSignalClass(signal.description)}>
          {` (${signal.signalStrength})`}
        </span>
      </div>
    );
  };

  const getStrength = (rowData: IConnectivityStatusByLocation) => {
    switch (rowData.signalStrengthDescription) {
      case WIFI_SIGNAL.POOR:
        return returnImage({
          image: poorImg,
          description: rowData.signalStrengthDescription,
          signalStrength: rowData.signalStrength
        });
      case WIFI_SIGNAL.GOOD:
        return returnImage({
          image: goodImg,
          description: rowData.signalStrengthDescription,
          signalStrength: rowData.signalStrength
        });
      case WIFI_SIGNAL.EXCELLENT:
        return returnImage({
          image: excellentImg,
          description: rowData.signalStrengthDescription,
          signalStrength: rowData.signalStrength
        });
      default:
        return returnImage({
          image: defaultImg,
          description: rowData.signalStrengthDescription,
          signalStrength: rowData.signalStrength
        });
    }
  };

  const getConnectedIcon = (row: IConnectivityStatusByLocation) => {
    return (
      <img
        src={row.isConnected ? connectedImg : disconnectedImg}
        alt="Connection"
        width={20}
      />
    );
  };

  const getActions = (row: IConnectivityStatusByLocation) => {
    return (
      <Link
        to={`/locations/${locationId}/applications/${row.deviceId}/timeline`}
      >
        View Timeline
      </Link>
    );
  };

  return (
    <DataTable
      value={data}
      size="small"
      scrollHeight="flex"
      scrollable
      paginator={data && data.length >= 50}
      selectionPageOnly
      rows={50}
      rowsPerPageOptions={[5, 10, 25, data ? data.length : 50]}
      tableStyle={{ fontSize: '14px' }}
    >
      <Column field="name" header="Name" sortable />
      <Column field="deviceId" header="Controller ID" sortable />
      <Column field="productType" header="Product Type" sortable />
      <Column field="accessPointMAC" header="Access Point" sortable />
      <Column
        field="isConnected"
        header={<Language />}
        sortable
        body={getConnectedIcon}
      />
      <Column
        field="connectionStatus"
        header={<Wifi />}
        sortable
        body={getStrength}
      />
      <Column field="" header="Actions" body={getActions} />
    </DataTable>
  );
};
